import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Table, Card, notification, Row, Col } from 'antd';
import CoinbaseCommerceButton from 'react-coinbase-commerce';
import { inject, observer } from 'mobx-react/index';

@inject('store')
@observer
export class SubscriptionLegacyView extends Component {
    constructor(props) {
        super(props);
        this.state = { subs: [] };
    }

    async componentDidMount() {
        const subs = await this.props.store.billingStore.getSubscriptionStatusForBot(
            this.props.store.botStore.bots[this.props.store.botStore.currentBot].pool_id
        );
        this.setState({ subs });
    }

    render() {
        const bot = this.props.store.botStore.bots[this.props.match.params.id];
        const poolStatus = this.props.store.botStore.poolBindings[bot.pool_id];

        return (
            <div>
                <Row type="flex" justify="center">
                    <Col md={8}>
                        <div className="package_wrapper">
                            <div className="package">
                                <div className="header">
                                    <h3>Apex VIP </h3>
                                    <div className="sub-heading">
                                        From <span className="colored-text strong">$35</span> p/m
                                        forever
                                    </div>
                                    <div className="sub-heading">
                                        <span style={{ textDecoration: 'line-through' }}>
                                            RRP $100
                                        </span>
                                    </div>
                                </div>
                                <div className="package-features">
                                    <ul>
                                        <li>
                                            <div className="column-9p">*Maximum Allocation</div>
                                            <div className="column-1p">
                                                <em className="fas fa-infinity" />
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="bottom-row">
                                        <div className="column-7p">$35 Per Month</div>
                                        <div className="column-3p" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                <p style={{ textAlign: 'center', marginTop: 10 }}>
                    * Maximum allocation is the total amount of funds which can be used to open
                    positions at any one time.
                </p>
                <p style={{ textAlign: 'center', marginTop: 10 }}>
                    * VIP price will be in effect up until cancellation.
                </p>

                <Row type="flex" justify="center">
                    <Col md={18}>
                        <Card
                            title={'Pay by Crypto'}
                            bordered={false}
                            style={{ marginBottom: 15 }}
                            size={'small'}
                            extra={
                                <CoinbaseCommerceButton
                                    styled
                                    customMetadata={JSON.stringify({
                                        uid: poolStatus.uid,
                                        pool_id: poolStatus.id
                                    })}
                                    checkoutId={'bf224074-6d1a-40f6-ba83-518330818dda'}
                                />
                            }
                        >
                            <Table
                                rowKey="id"
                                columns={[
                                    {
                                        title: 'Code',
                                        dataIndex: 'code',
                                        key: 'code'
                                    },
                                    {
                                        title: 'Bot',
                                        dataIndex: 'pool_id',
                                        key: 'pool_id'
                                    },
                                    {
                                        title: 'Created At',
                                        dataIndex: 'created_at',
                                        key: 'created_at'
                                    },
                                    {
                                        title: 'Confirmed',
                                        dataIndex: 'confirmed_at',
                                        key: 'confirmed_at'
                                    },
                                    {
                                        title: 'Description',
                                        dataIndex: 'description',
                                        key: 'description'
                                    }
                                ]}
                                dataSource={this.props.store.billingStore.cbSubs}
                            />
                        </Card>

                        <Card
                            title={'PayPal Subscriptions'}
                            bordered={false}
                            size={'small'}
                            extra={this.renderPaypalButton()}
                        >
                            <p>
                                On checkout you will be charged an initial <b>$35</b> and 30 days
                                will be added to your bot, your next subscription will be charged on
                                the day of your bots expiration.
                            </p>
                            <p>
                                You can cancel your recurring subscription at anytime from the
                                PayPal dashboard.
                            </p>
                            <Table
                                rowKey="id"
                                columns={[
                                    {
                                        title: 'State',
                                        dataIndex: 'state',
                                        key: 'state'
                                    },
                                    {
                                        title: 'Bot',
                                        dataIndex: 'pool_id',
                                        key: 'pool_id'
                                    },
                                    {
                                        title: 'Start Date',
                                        dataIndex: 'start_date',
                                        key: 'start_date'
                                    },
                                    {
                                        title: 'Next Billing Date',
                                        dataIndex: 'start_date',
                                        key: 'start_next_date',
                                        render(text, o) {
                                            return o.agreement_details.next_billing_date;
                                        }
                                    },
                                    {
                                        title: 'Description',
                                        dataIndex: 'description',
                                        key: 'description'
                                    }
                                ]}
                                dataSource={this.props.store.billingStore.paypalSubs}
                            />
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }

    renderPaypalButton() {
        if (this.props.store.billingStore.paypalSubs.filter(a => a.state === 'Active').length)
            return null;

        const paypal = window.paypal;
        let PayPalButton = paypal.Button.driver('react', { React, ReactDOM });

        return (
            <PayPalButton
                env="production"
                commit={true}
                client={{
                    sandbox:
                        'AUup4SaorWfncoRxYrqoD1IbINZxIM7Ek1YFcGkRV4WufXHmrWitRq8XW_UNafJbnb0HOPHOUE9nJpCx',
                    production:
                        'AYGpDsp-bolOLLEWVPmj0vQDgN-1iuaTXN8-tBgPnqT-I57c1FS3bGoSoj3VGEQng1PRtmpT3_s3NKfQ'
                }}
                payment={async () => {
                    const body = await this.props.store.billingStore.createUserAgreement(
                        this.props.store.botStore.bots[this.props.store.botStore.currentBot].pool_id
                    );
                    return new paypal.Promise(async (resolve, reject) => {
                        resolve(body.data.token);
                    });
                }}
                onAuthorize={async data => {
                    console.log('The payment was authorized!');
                    console.log('Payment ID = ', data);
                    await this.props.store.billingStore.executeUserAgreement(
                        data.paymentToken,
                        this.props.store.botStore.bots[this.props.store.botStore.currentBot].pool_id
                    );
                    notification['success']({
                        message: 'Payment Being Processed',
                        description:
                            'It may take 5-15 minutes to process you payment and apply your subscription time to your bot.'
                    });
                }}
                onCancel={data => {
                    console.log('The payment was cancelled!');
                    console.log('Payment ID = ', data);
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/SubscriptionLegacyView/index.js